export default __webpack_public_path__ + "static/media/RfqRequestDialogImg.a667b0fb.png";